export class Sort {
  name = 'id';
  dir = 'desc';
}
